<template>
  <section class="grey_bg" aria-labelledby="audit-heading">
    <div class="container mt-4">
      <h1 id="audit-heading" class="mt-4 page-title">Compliance Audit</h1>

      <h2 id="audit-report-heading" class="mt-4 section-heading">Annual Compliance Audit Report Requirements by Research Analysts</h2>

      <p>With respect to compliance with the annual compliance audit requirement under Regulation 25(3) of the Securities and Exchange Board of India (Research Analysts) Regulations, 2014, and clause (2.xiv.d) of the circular “Guidelines for Research Analysts” (SEBI/HO/MIRSD/ MIRSD-PoD-1/P/CIR/2025/004) dated January 08, 2025, all research analysts are required to publish the status of the compliance audit report on their website.</p>

      <p>Please find the same below for your reference:</p>

      <div class="table-responsive mt-4">
        <table class="table table-bordered table-striped" aria-labelledby="audit-report-heading">
          <caption class="visible-caption">Annual compliance audit status by financial year</caption>
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Financial Year</th>
              <th scope="col">Compliance Audit Status</th>
              <th scope="col">Remarks, if any</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>2021-2022</td>
              <td>Conducted</td>
              <td>Nil</td>
            </tr>
            <tr>
              <td>2</td>
              <td>2022-2023</td>
              <td>Conducted</td>
              <td>Nil</td>
            </tr>
            <tr>
              <td>3</td>
              <td>2023-2024</td>
              <td>Conducted</td>
              <td>Nil</td>
            </tr>
            <tr>
              <td>4</td>
              <td>2024-2025</td>
              <td>Conducted</td>
              <td>Nil</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br>
      <p><b>PROPRIETOR GROW WITH STOCKS)</b><br>
      GOUTAM SHARMA, Research Analyst<br>
      SEBI (Research Analysts) Regulations 2014,<br>
      Registration No. INH000001212<br>
      BSE Enlistment no. : 5078</p>
      <br>
    </div>
  </section>
</template>

<script>
export default {
  name: "ComplianceAudit",
  mounted() {
    document.title = "Compliance Audit | Grow With Stocks";
  }
};
</script>

<style lang="scss" scoped>
.grey_bg {
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 40px;
}
.page-title {
  text-align: center;
  color: #1a1a1a;
  font-weight: 700;
  margin-bottom: 24px;
  font-size: 32px;
}
.section-heading {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
}
p {
  color: #2d2d2d;
  line-height: 1.6;
}
th {
  background: #f1f1f1;
  color: #1a1a1a;
  font-weight: 700;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
/* WCAG 1.3.1 — visible table caption so it's reliably announced and seen */
.visible-caption {
  caption-side: top;
  text-align: left;
  padding: 8px 4px;
  font-weight: 600;
  font-size: 16px;
  color: #2d2d2d;
  background: transparent;
}
@media only screen and (max-width: 480px) {
  .page-title {
    font-size: 24px;
  }
  .section-heading {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ComplianceAudit.vue